import { useEffect, useState } from 'react';

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section
      id="top"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/96889edc57f7b2ab13416377f21356b6.webp"
          alt="ふぅばてぇ外観 - 宇検村の入口"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60" />
      </div>

      {/* Content */}
      <div
        className={`relative z-10 w-full max-w-4xl mx-auto px-6 text-center transition-all duration-1000 ${
          loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <span className="inline-block bg-tankan/90 text-white text-xs font-rounded font-bold tracking-widest px-4 py-1.5 rounded-full mb-6 uppercase">
          奄美大島・宇検村 / Takeout Pizza
        </span>

        <h1 className="sr-only">ふぅばてぇ｜奄美大島・宇検村の手ごね窯焼きピザ</h1>

        <p className="text-4xl md:text-6xl lg:text-7xl font-rounded font-black text-white leading-tight mb-5">
          宇検村の入口で、<br className="hidden sm:block" />焼きたてを。
        </p>

        <p className="text-base md:text-xl text-white/90 font-rounded font-medium leading-relaxed mb-10 max-w-xl mx-auto">
          手ごね生地を400℃の窯でパリッと。<br className="hidden md:block" />
          テイクアウトもできる小さなピザ屋です。
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => document.querySelector('#menu')?.scrollIntoView({ behavior: 'smooth' })}
            className="flex items-center justify-center gap-2 bg-tankan text-white font-rounded font-bold text-base px-8 py-4 rounded-full cursor-pointer hover:bg-tankan-dark transition-colors whitespace-nowrap"
          >
            <i className="ri-restaurant-line" />
            メニューを見る
          </button>
          <a
            href="tel:0997-69-4091"
            className="flex items-center justify-center gap-2 border-2 border-white text-white font-rounded font-bold text-base px-8 py-4 rounded-full cursor-pointer hover:bg-white/10 transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            電話で予約する
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-white/60 text-2xl" />
        </div>
      </div>

      {/* Rating badge */}
      <div className="absolute bottom-8 right-6 bg-white/90 backdrop-blur-sm rounded-2xl px-4 py-3 flex items-center gap-2 shadow-lg">
        <div className="flex gap-0.5">
          {[...Array(5)].map((_, i) => (
            <i key={i} className="ri-star-fill text-yellow-400 text-sm" />
          ))}
        </div>
        <span className="text-kiln font-rounded font-black text-sm">4.8</span>
        <span className="text-kiln/60 font-rounded text-xs">Google</span>
      </div>
    </section>
  );
}
